import type { CarPart, DamageType, InspectionSlot } from '@adbonus/core';
import { useI18n, type StringKey } from '../../lib/i18n';
import type { InspectionPhoto } from '../../lib/types';

/** Names for the inspection vocabulary, in the portal's language. */
export function useInspectionWords() {
  const { t } = useI18n();
  return {
    slot: (slot: InspectionSlot) => t(`inspection.slot.${slot}` as StringKey),
    damage: (type: DamageType) => t(`inspection.damage.${type}` as StringKey),
    part: (part: CarPart) => t(`inspection.part.${part}` as StringKey),
  };
}

/** One line saying what a photo shows: the side, or the mark and where it is. */
export function usePhotoLabel() {
  const words = useInspectionWords();
  return (photo: InspectionPhoto): string => {
    if (photo.slot !== 'DAMAGE') return words.slot(photo.slot);
    const what = photo.damageType ? words.damage(photo.damageType) : words.slot('DAMAGE');
    return photo.part ? `${what} · ${words.part(photo.part)}` : what;
  };
}
